import * as React from "react";
import { styled } from "styled-components";
import { Button, Image, Subheading, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  height: 340px;

  background: #ffffff;
`;

const LHColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 32px;
  gap: 16px;
  width: 448px;
`;

const StyledImg = styled(Image)`
  height: 90%;
  padding: 10px;
  aspectratio: 1/1;
`;

/**
 * OverviewPlaceholder component
 */
export const OverviewPlaceholder = (props: { supportLink: string }): UIElement => {
  const intl = useIntl();

  const heading = intl.formatMessage({
    id: "overview placeholder: unavailable",
    defaultMessage: "Overview dashboard is not available when an Amazon Store is connected",
  });

  const comingSoon = intl.formatMessage({
    id: "overview placeholder: coming soon",
    defaultMessage: "We are working to bring Insights related to Amazon stores to the Overview dashboard soon.",
  });

  const supportMessage = intl.formatMessage({
    id: "overview placeholder: ask support",
    defaultMessage: "If you want to have access to other stores’ insights, please reach out to support.",
  });

  const onClick = (e) => {
    window.location.href = props.supportLink;
    e.preventDefault();
  };

  return (
    <Container>
      <LHColumn>
        <Subheading> {heading} </Subheading>
        <Text> {comingSoon} </Text>
        <Text> {supportMessage} </Text>

        <Button variant="Tertiary" onClick={onClick}>
          {intl.formatMessage({ id: "overview placeholder: support button", defaultMessage: "Contact Support" })}
        </Button>
      </LHColumn>
      <StyledImg src="https://static.wayflyer.com/flyui-assets/images/insights-overview-placeholder.89e5bd0a26c2.png" />
    </Container>
  );
};
